export enum PlayerIcon {
	YOUTUBE = 'youtube',
	JUSTWATCH = 'justwatch',
}
